import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

import { MtnaPopoverModule } from '@mtna/lib-ui';

import { RdsChipsModule } from '../chips/index';
import { RdsVariableChipPipeModule } from '../core/pipes/variable-chip.pipe';
import { RdsVariableSelectionDialogModule } from '../variable-selection-dialog/index';
import { RdsMeasureSelectComponent } from './measure-select.component';

const COMPONENTS = [RdsMeasureSelectComponent];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatIconModule,
    MatSelectModule,
    MtnaPopoverModule,
    RdsChipsModule,
    RdsVariableSelectionDialogModule,
    RdsVariableChipPipeModule,
  ],
  exports: [COMPONENTS],
  declarations: [COMPONENTS],
})
export class RdsMeasureSelectModule {}

export * from './measure-option.model';
export * from './measure-select.component';
export * from './measure-selection.model';
